






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { DesignButtonStyle } from "@/services/styles/types";
import {
    getDesignButtonStyle,
    createDesignButtonStyle,
    updateDesignButtonStyle
} from "@/services/styles/designButtonStylesService";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";

import { settingsValidators } from "@/components/styles/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";

import { InteractionTypes } from "@/services/channels/types";
import { bus } from "@/bus";

@Component<DesignButtonStylesForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        UnsavedFormModal
    },
    directives: {
        validate
    }
})
export default class DesignButtonStylesForm extends Vue {
    @Prop() private designButtonStyleId!: string;
    _designButtonStyleId = this.designButtonStyleId;

    @Watch("CSS", { deep: true }) t() {
        this.cleanFixed();
    }

    interactionTypes = InteractionTypes;
    validators = settingsValidators;

    designButtonStyle = {
        id: "",
        name: "",
        css: {}
    } as DesignButtonStyle;

    // used for comparing if form have changes
    priorDesignButtonStyleState = JSON.parse(JSON.stringify(this.designButtonStyle)) as DesignButtonStyle;

    nextRoute = "";
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    fixedError = false;
    timeout = 0;
    routeParams = {};

    designButtonReload = 0;

    fetchData() {
        if (this._designButtonStyleId) {
            this.fetchingActive = true;
            getDesignButtonStyle(this._designButtonStyleId).then((response: DesignButtonStyle) => {
                this.designButtonStyle = response;
                bus.$emit("documentTitle", this.designButtonStyle.name);
                this.priorDesignButtonStyleState = JSON.parse(JSON.stringify(this.designButtonStyle));
                this.designButtonReload++;
                this.fetchingActive = false;
            });
        }
    }

    // Lifecycle hooks
    created() {
        this.initializeStyleId();
        this.fetchData();
    }

    // Computed
    get editMode() {
        return this._designButtonStyleId !== undefined;
    }

    // Methods
    initializeStyleId() {
        if (!this._designButtonStyleId) {
            this._designButtonStyleId = this.$route.params.designButtonStyleId;
        }
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorDesignButtonStyleState, this.designButtonStyle);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    cleanFixed() {
        for (const c in this.designButtonStyle.css) {
            if ((this.designButtonStyle.css as any)[c].toLowerCase().includes("fixed")) {
                this.fixedError = true;
                (this.designButtonStyle.css as any)[c] = (this.designButtonStyle.css as any)[c].replace(/fixed/gi, "absolute");
            }
        }
        if (this.fixedError) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.fixedError = false;
            }, 10000);
        }
    }

    // header buttons
    back() {
        window.history.go(-1);
    }

    // footer buttons
    async save(evt: any) {
        this.saveClicked = true;
        if (!await validateForm([this.validators])) return;
        this.cleanFixed();
        if (!this.editMode) {
            createDesignButtonStyle(this.designButtonStyle).then(() => {
                this.$router.push({ name: "designButtonStyles" });
            });
        } else {
            updateDesignButtonStyle(this.designButtonStyle).then(() => {
                this.$router.push({ name: "designButtonStyles" });
            });
        }
    }
}
